module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Medium.f76d323a.otf";